import { Button, Row } from '@tempmee/react';
import { InfoSection } from './components/InfoSection';
import { IEditableFormProps } from './Types';
import { JobDescriptionForm, JobDescriptionPreview } from './components/JobDescription';

export const JobDescriptionEditable = ({
  jobPosting,
  editMode,
  hideEditButton,
  disableSave,
  control,
  errors,
  onEditClick,
  onCancelClick,
  onSaveClick,
}: IEditableFormProps) => {
  const { description } = jobPosting || {};

  if (editMode) {
    return (
      <InfoSection
        icon="document-solid"
        title="Job Description"
        required
        rightAction={
          <Row gap={3}>
            <Button variant="secondary" size="xs" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button disabled={disableSave} size="xs" onClick={onSaveClick}>
              Save
            </Button>
          </Row>
        }
      >
        <JobDescriptionForm control={control} errors={errors} />
      </InfoSection>
    );
  }

  return (
    <InfoSection
      icon="document-solid"
      title="Job Description"
      rightActionIcon="edit-pencil"
      onRightActionPress={hideEditButton ? undefined : onEditClick}
    >
      <JobDescriptionPreview description={description || ''} />
    </InfoSection>
  );
};
